import React, { useContext } from 'react';
import { noResultConfig } from '../../../../DTInfoWidget/widgetConfig';
import { DTNoResultsLink } from '../../../../Common/DTNoResultsLink/DTNoResultsLink';
import DTNoResults from '../../../../Common/DTNoResults/DTNoResults';
import { getRbiCustomerId } from '../../../../../../extractFromState';
import { useSelector } from 'react-redux';
import { getOrderingSystem } from '../../../../../../selectors/tools';
import { CustomNoResultsComponentContext } from './CustomNoResultsComponentContext';

const NoSearchResults = () => {
  const rbiCustomerId = useSelector(getRbiCustomerId);
  const orderingSystem = useSelector(getOrderingSystem);
  const customComponent = useContext(CustomNoResultsComponentContext);

  const componentMap = {
    bigCommerce: <DTNoResults {...noResultConfig.bigCommerce} />,
    shopify: <DTNoResults {...noResultConfig.shopify} />,
    amazon: <DTNoResults {...noResultConfig.amazon} />,
    custom_rbi: (
      <DTNoResults {...(rbiCustomerId ? noResultConfig.rbiValidAccount : noResultConfig.rbiInvalidAccount)} />
    ),
    revolve: <DTNoResultsLink />,
    default: <DTNoResultsLink />,
  };

  return customComponent || componentMap[orderingSystem] || componentMap.default;
};

export default NoSearchResults;
